import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import Calendar from './index'

/**
 * Helper class for {@link Calendar} component
 * Because of customer requirements we need to supply the same event date for all timezones
 * To rich that we recalculate all dates to UTC time
 */

const convertTimezone = (date, eventType, end = false) => {
  if (!date) {
    return null
  }
  date = date.replace(/ /g, 'T')
  if (!date.includes('T')) {
    date += 'T00:00:00'
  }
  if (date && !date.endsWith('Z')) {
    date = date + 'Z'
  }
  let result = moment.utc(date).utcOffset(new Date().getTimezoneOffset() * -1).toDate()
  if (end) {
    result.getUTCHours() === 0 && result.setUTCHours(1)
  }
  return result
}
/**
 * Used to convert date by dropping event to save it into db
 */
const convertDateToUTC = (date, serverDate, format = 'YYYY-MM-DD') => {
  if (moment(date).isValid()) {
    const hour = moment(serverDate).get('hour')
    return moment.utc(date).set('hour', hour).format(format)
  } else {
    return null
  }
}
/**
 * format date according to format pattern
 */
const convertDate = (date, format = 'YYYY-MM-DD') => {
  if (date === 'clear') {
    return date
  }
  if (moment(date).isValid()) {
    return moment(date).format(format)
  } else {
    return null
  }
}

export {
  convertDate, convertDateToUTC, convertTimezone
}
